import './Sidebar.scss';

import Sidebar from './Sidebar';

export default Sidebar;
